import Image from 'next/image';

import CopyReferral from './CopyReferral';
import TotalReferrals from './TotalReferrals';

interface InviteCardProps {
  referralId: string;
  referredUsers: number;
  referralPoints: number;
}

const InviteCard: React.FC<InviteCardProps> = ({ referralId, referredUsers, referralPoints }: InviteCardProps) => {
  return (
    <div className='flex flex-1 flex-col'>
      <div className='flex flex-1 flex-col border border-border-primary bg-surface-primary rounded-t-2xl shadow-missions'>
        <div className='flex flex-1 flex-col justify-between gap-4 p-6 lg:p-8'>
          <div className='flex flex-col-reverse sm:flex-row gap-4 sm:gap-6'>
            <div className='flex flex-1 flex-col'>
              <p className='text-2xl font-medium text-text-primary'>Invite friends and earn Quanta</p>
              <p className='text-xl text-text-secondary'>
                Get Quanta for every friend you invite who completes a mission within the Ducat Protocol.
              </p>
            </div>
            <div className='flex flex-col items-end'>
              <div className='flex items-center gap-2'>
                <span className='text-2xl font-semibold text-text-primary'>+ 250</span>
                <Image src='/assets/quanta/quanta-points.png' alt='Quanta Points' width={26} height={26} />
              </div>
              <p className='text-xl text-text-secondary leading-none'>per friend</p>
            </div>
          </div>
          <div className='flex flex-col lg:flex-row lg:items-center gap-6'>
            <div className='shrink-0 sm:w-[250px]'>
              <CopyReferral title='Referral code' value={referralId} />
            </div>
            <div className='flex-1'>
              <CopyReferral title='Referral link' value={`https://app.ducatprotocol.com/quanta?referral=${referralId}`} />
            </div>
          </div>
        </div>
      </div>
      <div className='flex flex-col md:flex-row gap-4 md:gap-0 px-6 lg:px-8 py-6 border-x border-b border-border-primary bg-surface-primary rounded-b-2xl shadow-missions'>
        <TotalReferrals title='Successful referrals' amount={referredUsers} />
        <div className='hidden md:block w-px bg-border-primary mx-8 -my-6' />
        <TotalReferrals title='Total referral points' amount={referralPoints} />
      </div>
    </div>
  );
};

export default InviteCard;
